import splitArray from "./split-array";
import sortByKey from "./sort-by-key";

export const filteredCities = (cities, order = "desc") => {
    let [featured, notFeatured] = splitArray(cities, cityList => cityList.is_featured);
    //need to have it first sorted alphabetically then on display order.
    featured = sortByKey(sortByKey(featured, "city_name"), "display_order", order);
    notFeatured = sortByKey(notFeatured, "city_name");

    return {
        featured,
        notFeatured
    };
};

export default (cities) => {
    const { featured, notFeatured } = filteredCities(cities);
    return [...featured, ...notFeatured];
};
